import { elements, modifiers } from './styles.js'
import * as utilities from '#utilities/js/styles.js'
import { events } from '#utilities/js/lightboxes/lightbox.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import closest from '@mailobj-browser/front/js/selectors/closest.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'

const { open } = events

const onOpen = object(listener, {
  type: open,
  passive,
  task: async (
    opener,
    { detail: modal }
  ) => {
    const { ownerDocument } = opener
    const dropdownOpener = one(`.${utilities.modifiers.lightbox.dropdown}.${utilities.modifiers.lightbox.open}`, ownerDocument)
    const item = closest(`.${elements.item}`, dropdownOpener)
    item.classList.add(modifiers.item.editing)
    await removed(modal)
    item.classList.remove(modifiers.item.editing)
  }
})

export default button => {
  onOpen.listen(button)
}
